export default {
  default: {
    color: 'blue.1',
    '*': {
      fill: 'blue.1'
    },
    ':hover': {
      color: 'blue.0',
      '*': {
        fill: 'blue.0'
      }
    }
  },
  plain: {
    color: 'gray.1',
    '*': {
      fill: 'gray.1'
    },
    ':hover': {
      color: 'gray.0',
      '*': {
        fill: 'gray.0'
      }
    }
  },
  active: {
    color: 'yellow.1',
    '*': {
      fill: 'yellow.1'
    },
    ':hover': {
      color: 'yellow.0',
      '*': {
        fill: 'yellow.0'
      }
    }
  }
}
